import { RoomApiRoomListRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseQuery from './useBaseQuery';

export type Room = {
  id: string;
  name: string;
  isPasswordProtected: boolean;
  maxParticipants: number;
}

export const useRooms = (req: RoomApiRoomListRequest = {}) => useBaseQuery({
    queryKey: ['rooms', req],
    queryFn: (config) => appApiClient.roomApi.roomList(req, config),
  }); 